import { makeStyles } from '@material-ui/core';
import React from 'react';

const useItemStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'stretch',
    background: 'transparent',
    display: 'flex',
    flex: 1,
    flexBasis: 0,
    flexDirection: 'column',
    flexShrink: 1,
    fontSize: 14,
    fontWeight: 'bold',
    maxWidth: 90,
  },
  imageContainer: {
    background: ({ isActived }) => (
      isActived
        ? theme.palette.primary.main
        : '#ffffff'
    ),
    alignItems: 'stretch',
    border: 0,
    borderRadius: 8,
    boxShadow: '0 0 8px rgba(0, 0, 0, .3)',
    display: 'flex',
    height: 90,
    outline: 'none',
    padding: theme.spacing(2),
  },
  text: {
    fontSize: 16,
    marginTop: theme.spacing(1),
  },
}));

const Item = ({ isActived, data, onClick: propsOnClick }) => {
  const { name, imageUrl, value } = data;
  const classes = useItemStyle({ isActived });

  const onClick = () => {
    propsOnClick(value);
  };

  return (
    <div className={classes.root}>
      <button type="button" className={classes.imageContainer} onClick={onClick}>
        <div style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          flexGrow: 1,
        }}
        />
      </button>
      <div className={classes.text}>
        {name || '---'}
      </div>
    </div>
  );
};

const useStyle = makeStyles((theme) => ({
  root: {
    background: '#F4F4F4',
    display: 'flex',
    padding: theme.spacing(2),

    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
}));

export default ({ activedFilter, filters, onItemButtonClick }) => {
  const classes = useStyle();
  if (!filters || filters.length === 0) return null;
  return (
    <div className={classes.root} id="menu-filter">
      {(filters || []).map((filter) => {
        const { value } = filter || {};

        return <Item key={value || ''} isActived={value === activedFilter} data={filter} onClick={onItemButtonClick} />;
      })}
    </div>
  );
};
